import {Component, Inject} from '@angular/core';
import {IMwgData} from "../../../models/chart-mwg.model";
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogClose} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {ChartTableComponent} from "../../../components/chart-table/chart-table.component";

@Component({
  selector: 'colimo-offset-dialog',
  templateUrl: './offset-dialog.component.html',
  imports: [
    MatDialogActions,
    ChartTableComponent,
    MatDialogContent,
    MatDialogClose,
    MatButton
  ],
  styleUrls: ['./offset-dialog.component.scss']
})
export class OffsetDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      offsetDialogTitle: string;
      mwgData: IMwgData;
    }) {}
}
